import { Model } from '../../infra/model'
import { observable, makeObservable } from 'mobx'
import { Id } from '../../types/definitions'
import { DateZero, maybeParseDate } from '../../utils/date-util'
import Member from 'iam/models/Member'
import { PrimeMemberByPublicId } from 'iam/MemberStore'

export interface JobNoteProps {
  id: string
  job_id: string
  workspace_id: string
  body: string
  created_by_user_public_id: string
  recipient_user_public_ids: string[]
  date_created: string
}

/**
 * A note on a job.
 */
export class JobNote extends Model<JobNoteProps, JobNote> {
  id = Id.none
  jobId = Id.none
  workspaceId = Id.none
  body = ''
  author = Member.none
  recipientUserPublicIds: Id[] = []
  dateCreated = DateZero()

  constructor(private primeMember: PrimeMemberByPublicId) {
    super()
    makeObservable(this, {
      body: observable,
      author: observable,
      recipientUserPublicIds: observable,
      dateCreated: observable,
    })
  }

  parse(attrs: Partial<JobNoteProps>): Partial<JobNote> {
    return {
      id: attrs.id,
      jobId: attrs.job_id,
      workspaceId: attrs.workspace_id,
      body: attrs.body,
      author: this.primeMember({
        workspace_id: attrs.workspace_id,
        user_public_id: attrs.created_by_user_public_id,
      }),
      recipientUserPublicIds: attrs.recipient_user_public_ids ?? [],
      dateCreated: maybeParseDate(attrs.date_created),
    }
  }
}
